@switch (state) {
  @case ('loading') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc">
        <span class="state-spinner" aria-hidden="true"></span>
        <p class="state-text">Carregando pedido…</p>
      </div>
    </div>
  }

  @case ('invalid') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc">
        <div class="state-icon-wrap state-icon-wrap--muted">
          <span class="material-symbols-outlined state-icon">link_off</span>
        </div>
        <h2>Link inválido ou expirado</h2>
        <p>Verifique se você abriu o link mais recente enviado por e-mail. Se o problema persistir, contate a empresa compradora.</p>
      </div>
    </div>
  }

  @case ('encerrado') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc" [style.--cor-marca]="corMarca">
        <div class="state-icon-wrap state-icon-wrap--muted">
          <span class="material-symbols-outlined state-icon">block</span>
        </div>
        <h2>Pedido encerrado</h2>
        <p>Este pedido foi cancelado pela empresa compradora.</p>
      </div>
    </div>
  }

  @case ('sucesso') {
    <div class="portal-page portal-page--state">
      <div class="portal-doc state-doc" [style.--cor-marca]="corMarca">
        <div class="state-icon-wrap state-icon-wrap--brand">
          <span class="material-symbols-outlined state-icon" [style.color]="corMarca">check_circle</span>
        </div>
        <h2>Pedido confirmado!</h2>
        <p>
          Recebemos a confirmação do pedido
          <strong>{{ detalhe?.numeroPedido }}</strong>.
          A equipe de compras será notificada. Obrigado!
        </p>
      </div>
    </div>
  }

  @case ('gate') {
    <div class="portal-page portal-page--gate">
      <div class="portal-doc gate-doc" [style.--cor-marca]="corMarca">
        <header class="portal-hero" [style.background]="heroGradient">
          <div class="hero-brand">
            @if (resumo?.urlLogo) {
              <span class="hero-logo"><img [src]="resumo?.urlLogo" alt="Logo"></span>
            } @else {
              <span class="hero-logo-fallback" [style.background]="corMarca">{{ resumo?.marcaSigla || 'ATS' }}</span>
            }
            <div class="hero-brand-text">
              <strong>{{ resumo?.empresaNome }}</strong>
              <span>Portal do fornecedor</span>
            </div>
          </div>
        </header>

        <div class="gate-body">
          <div class="gate-icon-wrap">
            <span class="material-symbols-outlined gate-icon">lock</span>
          </div>
          <h2>Confirme sua identidade</h2>
          <p>Para abrir este pedido, informe os <strong>5 primeiros dígitos do CNPJ/CPF</strong> da sua empresa.</p>

          <form class="gate-form" (ngSubmit)="abrir()">
            <div class="gate-form-row">
              <label class="gate-field">
                <span class="gate-field-label">Primeiros 5 dígitos</span>
                <input class="gate-input" [(ngModel)]="documento" name="documento"
                  inputmode="numeric" maxlength="5" autocomplete="off"
                  placeholder="1 2 3 4 5" [disabled]="abrindo">
              </label>
              <button type="submit" class="btn-primary gate-submit" [style.background]="corMarca"
                [disabled]="abrindo || !podeAbrir">
                @if (abrindo) {
                  <span class="gate-spinner" aria-hidden="true"></span>
                  Abrindo…
                } @else {
                  <span class="material-symbols-outlined">lock_open</span>
                  Abrir pedido
                }
              </button>
            </div>
            @if (gateErro) { <p class="gate-erro">{{ gateErro }}</p> }
          </form>
        </div>
      </div>
    </div>
  }

  @case ('view') {
    <div class="portal-page">
      <div class="portal-doc">
        <header class="portal-hero" [style.background]="heroGradient">
          <div class="hero-brand">
            @if (detalhe?.urlLogo) {
              <span class="hero-logo"><img [src]="detalhe?.urlLogo" alt="Logo"></span>
            } @else {
              <span class="hero-logo-fallback" [style.background]="corMarca">{{ detalhe?.marcaSigla || 'ATS' }}</span>
            }
            <div class="hero-brand-text">
              <strong>{{ detalhe?.empresaNome }}</strong>
              <span>{{ detalhe?.marcaRodape || 'Pedido de compra' }}</span>
            </div>
          </div>
          <div class="hero-meta">
            <div class="hero-doc-type">Pedido de compra</div>
            <div class="hero-doc-number">{{ detalhe?.numeroPedido }}</div>
            <div class="hero-chips">
              @if (detalhe?.datetimeEnvioPedido) {
                <span class="hero-chip">
                  <span class="material-symbols-outlined">event</span>
                  Enviado em {{ detalhe?.datetimeEnvioPedido | date:'dd/MM/yyyy' }}
                </span>
              }
              @if (isConfirmado) {
                <span class="hero-chip">
                  <span class="material-symbols-outlined">verified</span>
                  Confirmado em {{ detalhe?.datetimeConfirmacaoPedido | date:'dd/MM/yyyy HH:mm' }}
                </span>
              }
            </div>
          </div>
        </header>

        <div class="portal-body">
          @if (detalhe?.mensagem) {
            <section class="portal-section">
              <p class="portal-mensagem">{{ detalhe?.mensagem }}</p>
            </section>
          }

          <section class="portal-section">
            <h3 class="portal-section-title"><i [style.background]="corMarca"></i>Itens do pedido</h3>
            <div class="items-scroll">
              <table class="items-table">
                <thead>
                  <tr>
                    <th class="num">Item</th>
                    <th>Produto</th>
                    <th class="num">Qtd</th>
                    <th>Un</th>
                    <th class="num">Preço unitário</th>
                    <th class="num">Tributos</th>
                    <th class="num">Desconto</th>
                    <th class="num">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of detalhe?.itens; track item.idCompraItem) {
                    <tr>
                      <td class="num">{{ item.item }}</td>
                      <td class="item-nome">
                        <strong>{{ item.nome }}</strong>
                        @if (item.codigoSku) { <small>SKU {{ item.codigoSku }}</small> }
                      </td>
                      <td class="num">{{ item.quantidade }}</td>
                      <td>{{ item.unidade }}</td>
                      <td class="num">{{ item.valorUnitario | currency:'BRL' }}</td>
                      <td class="num">{{ item.valorTributos | currency:'BRL' }}</td>
                      <td class="num">{{ item.valorDesconto | currency:'BRL' }}</td>
                      <td class="num">{{ item.subtotal | currency:'BRL' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <div class="totais-box">
              <div class="totais-row"><span>Subtotal dos itens</span><span>{{ detalhe?.subtotalItens | currency:'BRL' }}</span></div>
              @if (detalhe?.valorFrete != null) {
                <div class="totais-row"><span>Frete</span><span>{{ detalhe?.valorFrete | currency:'BRL' }}</span></div>
              }
              @if (detalhe?.valorOutrasDespesas != null) {
                <div class="totais-row"><span>Outras despesas</span><span>{{ detalhe?.valorOutrasDespesas | currency:'BRL' }}</span></div>
              }
              <div class="totais-row totais-row--total" [style.color]="corMarca">
                <span>Total geral</span><span>{{ detalhe?.valorTotal | currency:'BRL' }}</span>
              </div>
            </div>
          </section>

          @if (isAtivo('campoCondicoesPagamento') && (detalhe?.condicaoPagamento || detalhe?.parcelas?.length)) {
            <section class="portal-section">
              <h3 class="portal-section-title"><i [style.background]="corMarca"></i>Condições de pagamento</h3>
              @if (detalhe?.condicaoPagamento) {
                <p class="condicao-resumo">{{ detalhe?.condicaoPagamento }}</p>
              }
              @if (detalhe?.parcelas?.length) {
                <table class="parcelas-table">
                  <thead>
                    <tr><th>Parcela</th><th>Vencimento</th><th class="num">Valor</th></tr>
                  </thead>
                  <tbody>
                    @for (parcela of detalhe?.parcelas; track parcela.sequencia) {
                      <tr>
                        <td>{{ parcela.sequencia }}ª</td>
                        <td>
                          @if (parcela.dataVencimento) {
                            {{ parcela.dataVencimento | date:'dd/MM/yyyy' }}
                          } @else if (parcela.dias != null) {
                            {{ parcela.dias }} dias
                          } @else {
                            —
                          }
                        </td>
                        <td class="num">{{ parcela.valor != null ? (parcela.valor | currency:'BRL') : '—' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </section>
          }

          @if (isAtivo('campoPrazoEntrega') && (detalhe?.prazoEntrega || detalhe?.dataEntregaDesejada)) {
            <section class="portal-section">
              <h3 class="portal-section-title"><i [style.background]="corMarca"></i>Entrega</h3>
              <div class="info-grid">
                @if (detalhe?.prazoEntrega) {
                  <div class="info-item">
                    <small>Prazo de entrega</small>
                    <span>{{ detalhe?.prazoEntrega }}</span>
                  </div>
                }
                @if (detalhe?.dataEntregaDesejada) {
                  <div class="info-item">
                    <small>Entrega desejada</small>
                    <span>Até {{ detalhe?.dataEntregaDesejada | date:'dd/MM/yyyy' }}</span>
                  </div>
                }
              </div>
            </section>
          }

          @if (isAtivo('campoObservacoes') && detalhe?.observacoesPedido) {
            <section class="portal-section">
              <h3 class="portal-section-title"><i [style.background]="corMarca"></i>Observações do pedido</h3>
              <p class="portal-mensagem">{{ detalhe?.observacoesPedido }}</p>
            </section>
          }

          @if (gateErro) { <p class="gate-erro">{{ gateErro }}</p> }

          <section class="portal-section portal-submit">
            @if (isConfirmado) {
              <div class="pedido-confirmado-box">
                <span class="material-symbols-outlined">check_circle</span>
                Pedido confirmado. Obrigado!
              </div>
            } @else {
              <button type="button" class="btn-primary" [style.background]="corMarca" [disabled]="confirmando" (click)="confirmar()">
                <span class="material-symbols-outlined">task_alt</span>
                {{ confirmando ? 'Confirmando…' : 'Confirmar pedido' }}
              </button>
            }
          </section>
        </div>

        <footer class="portal-footer">
          {{ detalhe?.empresaNome }}
          @if (detalhe?.emailContato) { · {{ detalhe?.emailContato }} }
          @if (detalhe?.telefoneContato) { · {{ detalhe?.telefoneContato }} }
          @if (detalhe?.urlSite) { <br>{{ detalhe?.urlSite }} }
        </footer>
      </div>
    </div>
  }
}
